import { Button, Empty, Link } from "@/atoms"
import { useNumberConvertor } from "@/hooks/useNumberConvertor"
import { useOrderBy } from "@/hooks/useOrderBy"
import { useTooltip } from "@/hooks/useTooltip"
import { useTranslation } from "@/hooks/useTranslation"
import { useDeployments } from "@/pages/DeploymentsPage/application/useDeployments"
import {
  checkNoDeployments,
  useFiltersDeployments
} from "@/pages/DeploymentsPage/application/useFiltersDeployments"
import { TabTemplate } from "@/templates/TabTemplate"
import { FiltersDeploymentsTab } from "../FiltersDeploymentsTab"
import { HeaderDeploymentsTab } from "../HeaderDeploymentsTab"
import { getColumnsTable } from "./getColumnsTable"
import { getFilters } from "./getFilters"

import styles from "./DeploymentsTab.module.scss"

export const DeploymentsTab = () => {
  const { t } = useTranslation()
  const filters = getFilters(t)
  const { response, isLoading } = useDeployments(filters)
  const { response: options, isLoading: isLoadingFilters } =
    useFiltersDeployments()
  const { data = [], metadata } = response || {}
  const { onSorterChange, ...orderByProps } = useOrderBy()
  const twoLoaders = isLoading || isLoadingFilters
  const dataset = twoLoaders ? undefined : data
  const showCustomEmptyText = checkNoDeployments(options) && !twoLoaders
  const dataSource = showCustomEmptyText ? [] : dataset
  const { intlNumber: convertor } = useNumberConvertor()

  useTooltip(data)

  return (
    <>
      <TabTemplate
        resizable
        classes={{ row: styles.row }}
        headerComponent={<HeaderDeploymentsTab />}
        columns={getColumnsTable(orderByProps, {
          t,
          convertor,
          hasCloudConnections: data.some(({ platform }) => !!platform)
        })}
        loading={twoLoaders}
        metadata={metadata}
        dataSource={dataSource}
        locale={{
          emptyText: showCustomEmptyText && (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <div className={styles.emptyWrapper}>
                  <span>{t("deployments.noDeployments.line1")}</span>
                  <Link to="/deployments/new-deployment">
                    <Button type="link">
                      {t("deployments.noDeployments.line2")}
                    </Button>
                  </Link>
                </div>
              }
            />
          )
        }}
        onChange={(_pagination, _filters, sorter: any) => {
          onSorterChange(sorter)
        }}
        SearchComponent={<FiltersDeploymentsTab />}
      />
    </>
  )
}
